/**
* author: duxin
* date: 2020/4/8
* describe: 返回顶部
*/

<template>
    <transition name="back">
        <div class="back" @click="onTop" v-show="show"><i class="iconfont icontop"></i></div>
    </transition>
</template>

<script>
    const cubic = value => Math.pow(value, 3);
    const easeInOutCubic = value => value < 0.5
        ? cubic(value * 2) / 2
        : 1 - cubic((1 - value) * 2) / 2;

    export default {
        name: "kllk-backtop",
        props: {
            show: Boolean
        },
        methods: {
            onTop() {
                this.scrollToTop();
            },
            scrollToTop() {
                const el = document.getElementById("mainWrap");
                const beginTime = Date.now();
                const beginValue = el.scrollTop;
                const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
                const frameFunc = () => {
                    const progress = (Date.now() - beginTime) / 500;
                    if (progress < 1) {
                        el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
                        rAF(frameFunc);
                    } else {
                        el.scrollTop = 0;
                    }
                };
                rAF(frameFunc);
            }
        }
    }
</script>

<style lang="less" scoped>
    .back {
        width: 60px;
        height: 60px;
        background-color: #5266BF;
        border-radius: 50%;
        text-align: center;
        line-height: 60px;
        position: fixed;
        bottom: 30px;
        right: 30px;
        z-index: 10000;
        color: white;
        cursor: pointer;
        box-shadow: 2px 2px 5px -2px #08258F;
        &:hover{
            background-color: #E76C5E;
        }
    }

    .back-enter {
        bottom: -60px
    }

    .back-enter-active {
        transition: bottom .5s;
    }

    .back-leave-active {
        bottom: -60px;
        transition: bottom .5s;
    }

</style>